import { updateClusterMiddleware } from '@domain/omnichannel-budget-manager/update-cluster/update-cluster.middleware';
import { budgetManagerCampaignsModalMiddleware } from './modal/budget-manager-campaigns-modal.middleware';

export const budgetManagerMiddlewares = [
    budgetManagerCampaignsModalMiddleware,
    updateClusterMiddleware,
];
